import { find, values } from 'lodash';
import { compose, withProps } from 'recompose';

import { withOperationsStatus } from 'features/apolloOperationsObserver';

import { caseMutations } from '../../constants';

export default compose(
  withOperationsStatus(caseMutations, 'caseMutationsStatus'),
  withProps(({ caseMutationsStatus }) => ({
    isSaving: !!find(values(caseMutationsStatus), { isLoading: true }),
  })),
);



// WEBPACK FOOTER //
// ./src/compositions/CaseDetailOverviewPanel/withCaseSavingStatus.js